"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeledBapiClient = void 0;
const BapiClient_1 = require("./BapiClient");
function productWithFromMapping(productMapping) {
    return {
        advancedAttributes: productMapping.advancedAttributes
            ? {
                withKey: Object.keys(productMapping.advancedAttributes),
            }
            : undefined,
        attributes: productMapping.attributes
            ? {
                withKey: Object.keys(productMapping.attributes),
            }
            : undefined,
        variants: productMapping.variants
            ? {
                attributes: productMapping.variants.attributes
                    ? {
                        withKey: Object.keys(productMapping.variants.attributes),
                    }
                    : undefined,
            }
            : undefined,
    };
}
function productWithMappingApplied(bapiProduct, productMapping) {
    const mapped = {
        advancedAttributes: mapAdvancedAttributes(productMapping.advancedAttributes, bapiProduct.advancedAttributes),
        attributes: mapAttributes(productMapping.attributes, bapiProduct.attributes),
        variants: mapVariants(productMapping.variants, bapiProduct.variants),
        id: bapiProduct.id,
        isActive: bapiProduct.isActive,
        isSoldOut: bapiProduct.isSoldOut,
        isNew: bapiProduct.isNew,
        categories: bapiProduct.categories,
        images: bapiProduct.images,
        baseCategories: bapiProduct.baseCategories,
    };
    return mapped;
}
class ModeledBapiClient {
    constructor(env, mappings) {
        this.basket = {
            get: (basketKey) => __awaiter(this, void 0, void 0, function* () {
                const { basket, type, statusCode } = yield this.bapi.basket.get(basketKey, {
                    with: {
                        items: {
                            product: this.productWith,
                            variant: this.productWith.variants !== 'all'
                                ? this.productWith.variants
                                : undefined,
                        },
                    },
                });
                const itemsWithModel = basket.items.map(item => {
                    return Object.assign(Object.assign({}, item), { product: this.mapProduct(item.product) });
                });
                if (type === 'success') {
                    return {
                        type,
                        statusCode,
                        basket: Object.assign(Object.assign({}, basket), { items: itemsWithModel }),
                    };
                }
                else {
                    return {
                        type,
                        statusCode,
                        basket: Object.assign(Object.assign({}, basket), { items: itemsWithModel }),
                    };
                }
            }),
        };
        this.products = {
            getById: (productId) => __awaiter(this, void 0, void 0, function* () {
                const bapiProduct = yield this.bapi.products.getById(productId, {
                    with: this.productWith,
                });
                return this.mapProduct(bapiProduct);
            }),
            getByIds: (productIds_1, ...args_1) => __awaiter(this, [productIds_1, ...args_1], void 0, function* (productIds, params = {}) {
                const products = yield this.bapi.products.getByIds(productIds, Object.assign(Object.assign({}, params), { with: this.productWith }));
                return products.map(this.mapProduct);
            }),
            query: (params) => __awaiter(this, void 0, void 0, function* () {
                const { entities, pagination } = yield this.bapi.products.query(Object.assign(Object.assign({}, params), { with: this.productWith }));
                return {
                    products: entities.map(this.mapProduct),
                    pagination,
                };
            }),
        };
        this.bapi = new BapiClient_1.BapiClient(env);
        this.categories = this.bapi.categories;
        this.filters = this.bapi.filters;
        this.mapProduct = p => productWithMappingApplied(p, mappings.product);
        this.productWith = productWithFromMapping(mappings.product);
    }
}
exports.ModeledBapiClient = ModeledBapiClient;
function isSingleValue(o) {
    return (o.multiSelect === false &&
        o.values &&
        !Array.isArray(o.values) &&
        typeof o.values === 'object');
}
function mapVariants(variantMapping, variants) {
    if (!variantMapping || Object.keys(variantMapping).length === 0) {
        return [];
    }
    if (!variants) {
        throw new Error(`Have mapping for variants, but received none`);
    }
    return variants.map((variant) => {
        return {
            id: variant.id,
            attributes: mapAttributes(variantMapping.attributes, variant.attributes),
        };
    });
}
function mapAttributes(attributeMapping, attributes) {
    if (!attributeMapping || Object.keys(attributeMapping).length === 0) {
        return {};
    }
    if (!attributes) {
        throw new Error(`Have mapping for attributes, but received none`);
    }
    return Object.keys(attributeMapping).reduce((mappedAttributes, key) => {
        const mapping = attributeMapping[key];
        const attribute = attributes[key];
        if (!attribute &&
            (mapping === 'value?' ||
                mapping === 'value.label?' ||
                mapping === 'value.asString?' ||
                mapping === 'value.asBoolean?' ||
                mapping === 'value.asNumber?')) {
            return mappedAttributes;
        }
        if (!attribute) {
            throw new Error(`Missing required attribute ${key}`);
        }
        if (!isSingleValue(attribute)) {
            throw new Error(`Attribute ${key} is not a single value attribute`);
        }
        switch (mapping) {
            case 'value':
                mappedAttributes[key] = attribute.values;
                break;
            case 'value.label':
                if (typeof attribute.values.label !== 'string') {
                    throw new Error(`"label" of attribute "${key}" is not of type "string"`);
                }
                mappedAttributes[key] = attribute.values.label;
                break;
            case 'value.asString':
                if (typeof attribute.values.label !== 'string') {
                    throw new Error(`"value" of attribute "${key}" is not of type "string"`);
                }
                mappedAttributes[key] = attribute.values.value;
                break;
            case 'value.asBoolean':
                if (attribute.values.value === 'true') {
                    mappedAttributes[key] = true;
                }
                else if (attribute.values.value === 'false') {
                    mappedAttributes[key] = false;
                }
                else {
                    throw new Error(`"value" of attribute "${key}" is not of neither "true" nor "false"`);
                }
                break;
            case 'value.asNumber':
                if (attribute.values.value === undefined ||
                    attribute.values.value === null ||
                    attribute.values.value === '') {
                    throw new Error(`"value" of attribute "${key}" is not set`);
                }
                const n = +attribute.values.value;
                if (isNaN(n)) {
                    throw new Error(`"value" of attribute "${key}" is not a number`);
                }
                mappedAttributes[key] = n;
                break;
            default:
                throw new Error(`Unexpected mapping "${mapping}"`);
        }
        return mappedAttributes;
    }, {});
}
function mapAdvancedAttributes(attributeMapping, attributes) {
    if (!attributeMapping || Object.keys(attributeMapping).length === 0) {
        return {};
    }
    if (!attributes) {
        throw new Error(`Have mapping for advanced attributes, but received none`);
    }
    return Object.keys(attributeMapping).reduce((mappedAttributes, key) => {
        const mapping = attributeMapping[key];
        const attribute = attributes[key];
        if (!attribute) {
            throw new Error(`Missing required attribute ${key}`);
        }
        switch (mapping) {
            case 'numberValue': {
                const firstFieldSetValue = attribute.values[0].fieldSet[0][0].value;
                if (typeof firstFieldSetValue !== 'number') {
                    throw new Error(`Advanced attribute "${key}" has no value of type number`);
                }
                mappedAttributes[key] = firstFieldSetValue;
                break;
            }
            case 'asNumber': {
                const firstFieldSetValue = attribute.values[0].fieldSet[0][0].value;
                if (typeof firstFieldSetValue !== 'string') {
                    throw new Error(`Advanced attribute "${key}" has no value of type string (to be converted to number)`);
                }
                if (firstFieldSetValue === '') {
                    throw new Error(`Advanced attribute "${key}" contains empty string`);
                }
                const n = +firstFieldSetValue;
                if (isNaN(n)) {
                    throw new Error(`Advanced attribute "${key}" resulted in NaN`);
                }
                mappedAttributes[key] = n;
                break;
            }
            case 'stringValue': {
                const firstFieldSetValue = attribute.values[0].fieldSet[0][0].value;
                if (typeof firstFieldSetValue !== 'string') {
                    throw new Error(`Advanced attribute "${key}" has no value of type string`);
                }
                mappedAttributes[key] = firstFieldSetValue;
                break;
            }
            case 'stringListValue': {
                const values = attribute.values[0].fieldSet.map(field => field[0].value);
                if (!values.every(value => typeof value === 'string')) {
                    throw new Error(`Advanced attribute "${key}" hadn't all values of type "string"`);
                }
                mappedAttributes[key] = values;
                break;
            }
            case 'asMaterialComposition':
                mappedAttributes[key] =
                    materialCompositionFromAdvancedAttribute(attribute);
                break;
            default:
                throw new Error(`Unexpected mapping "${mapping}"`);
        }
        return mappedAttributes;
    }, {});
}
function materialCompositionFromAdvancedAttribute(attribute) {
    return attribute.values.map(value => {
        return {
            label: value.fieldSet[0][0].materialGroupName,
            materials: value.groupSet[0].fieldSet.map(fieldSet => {
                return {
                    value: fieldSet[0].value,
                    unit: fieldSet[1].unit,
                    label: fieldSet[2].material,
                };
            }),
        };
    });
}
